var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWwPayPal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "980px",
    height: "680px",
    viewBox: "0 0 980 680",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WW PayPal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEDED",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-2",
    x: 2.84217094e-14,
    y: 0,
    width: 900,
    height: 600,
    rx: 80
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.7%",
    y: "-10.0%",
    width: "113.3%",
    height: "120.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WW-PayPal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(246.9999, 50)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.865363,99.9866347 C151.774943,99.9924908 145.740408,105.15112 144.631677,112.15432 L120.98126,262.153763 C122.083869,255.148295 128.120378,249.986077 135.214946,249.986077 L204.517852,249.986077 C274.266256,249.986077 333.45077,199.104547 344.265253,130.152472 C345.070007,125.004648 345.525827,119.808309 345.629593,114.598995 C327.90431,105.304777 307.082811,99.9866347 284.267704,99.9866347 L158.865363,99.9866347 Z",
    id: "Path",
    fill: "#001C64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.629593,114.604564 C345.525827,119.813877 345.070007,125.010217 344.265253,130.15804 C333.45077,199.110116 274.260687,249.991646 204.517852,249.991646 L135.214946,249.991646 C128.125947,249.991646 122.083869,255.148295 120.98126,262.159332 L99.23535,399.996657 L85.6142245,486.467973 C85.0762267,489.849056 86.0468703,493.296084 88.2700753,495.899645 C90.4932803,498.503205 93.7457307,500 97.1693493,500 L172.39182,500 C179.482241,499.994142 185.516775,494.835513 186.625506,487.832313 L206.439065,362.162673 C207.548458,355.155309 213.58925,349.995368 220.683889,349.994987 L264.972037,349.994987 C334.720442,349.994987 393.904956,299.113456 404.719439,230.161381 C412.398725,181.223339 387.751504,136.695735 345.629593,114.610133 L345.629593,114.604564 Z",
    id: "Path",
    fill: "#0070E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4075576,0 C66.3185581,0 60.2764808,5.1566485 59.1738713,12.1565482 L0.145281584,386.464632 C-0.974034127,393.570337 4.51673846,399.996657 11.7115439,399.996657 L99.2464875,399.996657 L120.98126,262.159332 L144.631677,112.159889 C145.740408,105.156689 151.774943,99.9980595 158.865363,99.9922035 L284.267704,99.9922035 C307.088379,99.9922035 327.90431,105.315914 345.629593,114.604564 C346.843578,51.8282155 295.043206,0 223.824655,0 L73.4075576,0 Z",
    id: "Path",
    fill: "#003087"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWwPayPal);
export default __webpack_public_path__ + "static/media/WW PayPal.abb022223eefa5393867cb679ccff784.svg";
export { ForwardRef as ReactComponent };